import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconClone: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        d="M19.9999 9.7795H21.4025L18.8311 7.20801V8.61068C18.8311 9.25512 19.3554 9.7795 19.9999 9.7795Z"
        fill={fill}
      />
      <path
        d="M11.8182 5.80587H13.2209L10.6494 3.23438V4.63705C10.6494 5.28148 11.1738 5.80587 11.8182 5.80587Z"
        fill={fill}
      />
      <path
        d="M19.9996 10.9486C18.7139 10.9486 17.662 9.89667 17.662 8.61092V6.97461H14.623V14.6888C14.623 16.6222 13.0499 18.1953 11.1165 18.1953H10.1816V18.6628C10.1816 19.9485 11.2335 21.0004 12.5192 21.0004H19.2984C20.5841 21.0004 21.636 19.9485 21.636 18.6628V10.9486H19.9996Z"
        fill={fill}
      />
      <path
        d="M11.8181 6.97412C10.5324 6.97412 9.48046 5.92222 9.48046 4.63647V3.00016L2 3V14.6882C2 15.974 3.0519 17.0259 4.33764 17.0259H11.1168C12.4026 17.0259 13.4545 15.974 13.4545 14.6882V6.974L11.8181 6.97412ZM8.07779 13.4026H4.57133V12.2338H8.07779V13.4026ZM10.8831 10.8311H4.57145V9.66233H10.8831V10.8311Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconClone;
